<!-- Main Page Start -->
<section class="skillsWrap">
  <div class="left-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="right-panel">
          <h4 class="pageTitle"> Projects undertaken <a data-toggle="modal" data-target="#addModal" data-dismiss="modal" class="addMoreBtn" (click)="openAddModal(addMore)">  <i class="pluseIcon"><img src="../../../../assets/images/ic_plus.svg"> </i> Add More </a></h4>

          <div class="education_added">
              <ul class="timeline">
                  <li *ngFor="let result of allData; let i =index;"> 
                      <span class="timeline-point-circle fill"></span>
                      <div class="el_details"> 
                          <p> <strong class="firstlCaptial">{{result.projectTitle || "N/A"}}</strong> 
                            <span class="actionButton">
                              <a href="javascript:;" (click)="edit(result,addMore)" title="Edit"><img src="../../../../assets/images/ic_edit.svg" class="ht"> </a>
                              <a href="javascript:;"  (click)="delete(result.id)" title="Delete"><img src="../../../../assets/images/ic_delete.svg" class="ht"> </a>
                            </span>

                          </p> 
                          <p class="para3">{{result.associatedWith || "N/A"}} </p>  
                            
                              <ul class="mt-4">
                              <li><span class="ft-wt"> Duration : </span> {{result.fromDate | date}} - {{result.toDate == null ? "Currently Ongoing" : result.toDate | date}}</li>
                              
                              <li><span class="ft-wt">Project description : </span> {{result.description || " N/A"}}</li>
                          </ul>
                          </div>
                          <div class="el_details" *ngIf="result.projectTeamMembersDetails.length>0"> 
                            <p> <strong>Team member</strong>
                              <ul>
                              <li *ngFor="let mem of result.projectTeamMembersDetails; let j =index"><span class="width50"> {{mem.name}}</span> {{mem.email}}</li> 
                              </ul> 
                          </div>
                          <div class="el_details"> 
                            <p> <strong>Media</strong>
                              <ul class="medias">
                                <li class="thumbnailIcon" *ngFor="let thumb of _albums[i]; let j =index">
                                  <span >
                                    <img [src]="thumb.src" (click)="open(j)" class="image"/>
                                </span>
                                 
                              </li> 
                              </ul> 
                          </div>
                          <div class="el_details" > 
                            <p> <strong>Links</strong>
                              <ul>
                              <li *ngFor="let link of result.projectLinksDetails; let i =index" class="noAfter">
                                <a [href]="link.link" target="_blank" class="blue-text">{{link.link || "N/A"}}</a>
                              </li> 
                              </ul> 
                          </div>
                      
                  </li> 
              </ul>
          </div>

          <div class="form-group  ">
              <a href="javascript:void(0)" routerLink="/awards" class="commonBtn width50 mt-5">Continue</a>
          </div>
  </div>
</section>

<!-- End -->

<ng-template #addMore>
    <div class="modal-body">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeAddModal()"><span aria-hidden="true">×</span></button>             
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <h4 class="pageTitle"> {{title}} Projects Undertaken</h4>
        <div class="row">
            <div class="col-md-6 col-lg-6 ">
                <div class="form-group">
                    <label>Associated with</label>
                    <input type="text"  class="form-control upper" placeholder="Child care supervisor" formControlName="associatedWith"> 
                    <div class="text-danger" *ngIf="form.controls['associatedWith'].hasError('required') && showError">
                      *Please enter associated with.
                  </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 ">
                <div class="form-group">
                    <label> Project title <span class="orangeText">*</span> </label>
                    <input type="text"  class="form-control upper" placeholder="Enter" formControlName="projectTitle"> 
                    <div class="text-danger" *ngIf="form.controls['projectTitle'].hasError('required') && showError">
                      *Please enter project title.
                  </div> 
                  <div class="text-danger" *ngIf="form.controls['projectTitle'].hasError('maxlength') && showError">
                    *Maximum length of 50 characters.
                </div>
                </div>
            </div>
            
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="form-group">
                    <label>Location</label>
                    <input type="text"  class="form-control upper" placeholder="Enter" formControlName="location"> 
                    <div class="text-danger" *ngIf="form.controls['location'].hasError('required') && showError">
                      *Please enter location.
                  </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class=" d-flex justify-content-between">
                    <div class="form-group">
                        <label> From </label>
                        <div id="date-picker-example" class="datepicker">
                          <input type="text" autocomplete="off" class="form-control" placeholder="Enter date" bsDatepicker placement="bottom" [bsValue]="form.value.fromDate" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" formControlName="fromDate" [maxDate]="maxDate" (keydown)="onKeyDown($event)">
                          <span class="ic_calendar"><img src="../../../../assets/images/ic_calendar.svg"></span>
                      </div>
                      <div class="text-danger" *ngIf="showError == true && form.controls['fromDate'].hasError('required')">*Please select From</div>
                    </div>

                    <div class="form-group">
                        <label> To </label>
                        <div id="date-picker-example" class="datepicker">
                          <input type="text" placeholder="Enter date"
                          class="form-control" bsDatepicker
                          [minDate]="form.value.fromDate == '' ? minDate : form.value.fromDate"
                          [maxDate]="maxDate"
                          formControlName="toDate"
                          [bsValue]="form.value.toDate"
                          [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" (keydown)="onKeyDown($event)">
                          <span class="ic_calendar"><img src="../../../../assets/images/ic_calendar.svg"></span>
                      </div>
                      <div class="text-danger" *ngIf="showError == true && form.controls['toDate'].hasError('required')">*Please select To</div>
                    </div>
                </div>
            </div>
            
           
            <div class="col-md-6 col-lg-6 col-sm-12">
                <div class="form-group pt-2">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="customCheckBox1" formControlName="isCurrentlyOngoing" [value]="1" [checked]="form.value.isCurrentlyOngoing == 1" (change)="form.value.isCurrentlyOngoing=1;isDisabled($event)">
                      <label class="custom-control-label" for="customCheckBox1"> I am currently working in this role</label>
                      <div class="text-danger" *ngIf="form.controls['isCurrentlyOngoing'].hasError('required') && showError">
                          *Please accept select.
                      </div>
                    </div>
                </div>
            </div>
              <div class="col-md-12 col-lg-12  col-sm-12">
                <h6 class="pageTitle subTitle2"> Team Members <a data-toggle="modal" data-target="#addMember" data-dismiss="modal" class="addMoreBtn"  (click)="openTeamModal(addMember)"> <i class="pluseIcon"><img src="assets/images/ic_plus.svg"> </i> Add more member </a></h6> 

              </div>
            
              <div class="row addmemeber m-0 p-0">
                <div class="col-lg-4 col-md-6 col-sm-12"  *ngFor="let data of form.value.projectMembers; let i=index;">
                    <div class="form-group">
                        <div class="joinservice"> 
                            <div><span  class="name">{{data.name}}</span> <p class="email">{{data.email}}</p></div>
                            <div>
                            <div class="action">
                                <a href="javascript:void(0);" (click)="editMember(i,addMore)" title="Edit"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                                <a href="javascript:void(0);" (click)="deleteMember(i)" title="Delete"><img src="assets/images/ic_delete.svg" class="ht"> </a> 
                           </div>
                        </div>
                        </div>
                    </div>
                </div> 
             </div>
            <div class="col-md-12 col-lg-12  col-sm-12">
                <h5 class="subTitle2">Project detail</h5>  
                <div class="form-group">
                    <label> Add project description</label>
                    <textarea type="text" class="form-control" placeholder="Write here" formControlName="description" maxlength="250"></textarea>
                    <div class="text-danger" *ngIf="form.controls['description'].hasError('required') && showError">
                        *Please enter description.
                    </div>
                    <div class="text-danger" *ngIf="form.controls['description'].hasError('minlength') && showError">
                        *Minimum length of 3 characters.
                    </div>
                    <div class="text-danger" *ngIf="form.controls['description'].hasError('maxlength') && showError">
                        *Minimum length of 250 characters.
                    </div>
            </div>
          </div>
            <div class="col-md-12 co-sm-12 col-lg-12 " >
                <div class="form-group">
                    <label>  Project Links  </label>
                    <div class="p-relative">
                          <input type="text" class="form-control" placeholder="Enter"  #hAwards formControlName="projectLinksTypeOf">
                          <a href="javascript:void(0);" class="addMore" (click)="addHonors( hAwards.value)" title="Add More"><img src="../../../../../../../../assets/images/add-circle.svg"/></a>
                     </div> 
                     <div class="text-danger"
                      *ngIf="showErrorToAdd">
                      *Please click on Plus icon to add project links.
                      </div>
                      <div class="text-danger"
                          *ngIf="showLinkSameError">
                          *Please add different  project links.
                      </div>
                      <div class="text-danger"
                          *ngIf="form.controls['projectLinksTypeOf'].hasError('pattern') && showError">
                          *Please enter valid project link.
                      </div>
                </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2" *ngFor="let awards of awardList;let i=index" >
                      <div class="joinservice"> {{awards.link != null ? awards.link : awards.name}}<a  href="javascript:void(0)" (click)="deleteHonors(i)" title="Delete"><img src="../../../../assets/images/ic_delete.svg"> </a></div>
                        </div> 
              </div>
            </div>
            <div class="col-md-6 co-sm-12 col-lg-6">
                <div class="form-group">
                    <label> Add project media  </label>                          
                    <div class="imagesBox">
                      <div class="customfileupload">
                          <input type="file" id="myfile" name="myfile" accept=".png, .jpg, .jpeg" #myInput (change)="upload($event)">
                          <p><span><img src="../../../../assets/images/upload.svg"></span></p>
                      </div>
                      <div  class="thumbnailIcon" *ngFor="let image of thumbnailImage; let i=index;">
                        <a href="javascript:void(0);" class="close" (click)="deleteImage(i)" title="Delete"><img src="../../../../assets/images/ic_close_image.svg"></a>
                        <img [src]="globalUrl + image.fileName" class="image" (click)="open(i)"/>
                      </div> 
                    </div>
                </div>
            </div>

        </div>
  
        <div class="form-group ">
          <input type="submit" value="Save"  class="commonBtn width50 mt-4">
        </div>
  
    </form>
    </div>
  </ng-template>
  <ng-template #addMember>
    <div class="modal-body">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="this.modalRef?.hide()"><span aria-hidden="true">&times;</span></button>             
      <form [formGroup]="addTeam" (ngSubmit)="onAddTeam()">
        <h4 class="pageTitle mb-3"> {{titleTeam}} Team Members</h4>
        <div class="row">
            <div class="form-group  col-sm-6 col-md-6 col-lg-6">
            <label> Full Name </label>
            <input type="text" class="form-control" name="" placeholder="Enter" formControlName="name" maxlength="30"/> <div class="text-danger" *ngIf="addTeam.controls['name'].hasError('required') && showTeamMemberError">
                *Please enter name.
              </div>
        </div>
            
        <div class="form-group col-sm-6 col-md-6 col-lg-6">
            <label> Email </label>
            <input type="email" class="form-control" name="" placeholder="Enter" formControlName="email"/> <div class="text-danger" *ngIf="addTeam.controls['email'].hasError('required') && showTeamMemberError">
                *Please enter email.
              </div>
              <div class="text-danger" *ngIf="addTeam.controls['email'].hasError('pattern') && showTeamMemberError">
                  *Invalid email. Please try again..
              </div>
        </div>
        </div>
      <div class="form-group mt-2">
          <input type="submit" class="commonBtn width50" value="Save">
      </div>
  </form>
    </div>
</ng-template>